export const cases = [
  {
    slug: "case-fukuoka-mansion-trash",
    category: "日常清掃ゴミ庫",
    title: "築20年以上マンションのゴミ庫を綺麗に",
    location: "福岡県・福岡市",
    scale: "5階建",
    period: "契約8ヶ月継続中",
    price: "¥",
    problem:
      "ゴミ庫周辺に生ゴミの残りや汚れが蓄積し、カラスが集まりやすい環境に。",
    solution:
      "ゴミ庫内の床・壁等を徹底洗浄し、ゴミ汁や臭いの原因となる汚れを除去。",
    result:
      "ゴミ庫周辺の衛生環境が改善され、カラスが寄りつきにくい環境に繋がる。",
    image:
      "images/building-trash.jpg",
  },
  // 
  {
    slug: "case-fukuoka-mansion-toilet",
    category: "日常清掃WC",
    title: "共用トイレを2週間の着手でピカピカに",
    location: "福岡県・福岡市",
    scale: "4階建",
    period: "契約1ヶ月継続中",
    price: "¥",
    problem:
      "床や便器の汚れが目立ち、水垢による臭いも気になっていた。汚れを落とすのが難しい状況だった。",
    solution:
      "便器・床・壁面を重点的に洗浄。水垢には汚れの種類に合わせた洗剤を使用し、丁寧に清掃。最後に除菌・消臭を実施。",
    result:
      "頑固な汚れや臭いが改善され、明るく清潔感のあるトイレに。住民様からも「以前よりきれいになった」と評価された。",
    image:
      "images/building-wc.jpg",
  },
  {
    slug: "house-cleaning",
    category: "原状回復",
    title: "退去後のお部屋を次の入居者様が気持ちよく使える状態に",
    location: "福岡県、福岡市",
    scale: "6階建て",
    period: "契約1年経過",
    price: "¥",
    problem:
      "長期間使用されていたため、床の黒ずみ、キッチンの油汚れ、浴室の水垢などが蓄積していた。",
    solution:
      "汚れの状態を確認したうえで、場所ごとに適切な清掃方法を選択。キッチンの油汚れ、浴室の水垢などを重点的に除去。",
    result:
      "蓄積していた汚れが改善され、室内全体が明るく清潔な印象に。次の入居者様が気持ちよく生活できる状態に。協力会社様からも感謝のお言葉をいただく。",
    image:
      "images/repair.webp",
  },
  
];

